import { Directive, HostListener, inject, InjectionToken } from '@angular/core';
import { UnsavedChangeAlert } from '../../core/guards/unsaved-changes-warning.guard';
import { ModeIcons } from '../utility/constants';

export const UNSAVED_CHANGES_DATA_COMPONENT =
  new InjectionToken<UnsavedChangeAlert>('Component accessor');

@Directive({
  selector: '[appUnsavedChangesWarning]',
  standalone: true,
})
export class UnsavedChangesWarningDirective {
  component: UnsavedChangeAlert | null = inject<UnsavedChangeAlert | null>(
    UNSAVED_CHANGES_DATA_COMPONENT,
    { optional: true }
  );

  @HostListener('window:beforeunload', ['$event'])
  async beforeUnload(event: BeforeUnloadEvent) {
    // only show if component is in edit / create
    if (
      this.component?.pageMode &&
      ![ModeIcons.add, ModeIcons.edit].includes(this.component.pageMode)
    ) {
      return;
    }

    if (await this.component?.hasUnsavedChanges?.()) {
      event.preventDefault();
      event.returnValue = 'Has Unsaved changes';
    }
  }
}
